import { useTeamQuery } from "@/lib/queries/team-queries";
import { useParams } from "react-router";
import { cn, formatNumber } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/lib/components/Tooltip";
import { useIsMobile } from "@/lib/use-mobile";
import { Button } from "@/lib/components/Button/Button";
import { IconGift } from "@tabler/icons-react";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import ReferralOverviewDialog from "@/features/Referral/ReferralOverviewDialog";

export default function CreditBalance() {
  const { teamExternalId } = useParams();
  const { data: team } = useTeamQuery(teamExternalId!);
  const isMobile = useIsMobile();
  const setIsCreditDialogOpen = useEditorStore(
    (state) => state.service.setIsCreditDialogOpen,
  );

  if (!team || !team.billingInfo.showCredits || isMobile) {
    return null;
  }

  const balanceText =
    team.billingInfo.creditBalance === 0
      ? "No credits"
      : formatNumber(team.billingInfo.creditBalance);

  return (
    <>
      <ReferralOverviewDialog source="EDITOR">
        <Button
          size="sm"
          variant="tertiarySecondary"
          icon={<IconGift />}
          iconPosition="leading"
        >
          Earn $100
        </Button>
      </ReferralOverviewDialog>
      <div className="w-3"></div>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="mr-8 flex cursor-pointer items-center justify-center"
            onClick={() => setIsCreditDialogOpen(true)}
          >
            <img
              src="/CreditIcon.svg"
              alt=""
              className="mr-1.5 mb-0.75 h-5 w-5"
            />
            <span
              className={cn(
                "font-semibold",
                balanceText.length > 5 ? "text-sm" : "text-base",
              )}
            >
              {balanceText}
            </span>
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Credit balance</p>
        </TooltipContent>
      </Tooltip>
      <div className="w-10"></div>
    </>
  );
}
